import { ResolveFn } from '@angular/router';
import { environment } from '../../environments/environment';

export const homePageUrlResolver: ResolveFn<string | null> = ():
  | string
  | null => {
  return environment.LIFERAY_PIU_HOME_PAGE_URL;
};
